import i18n from 'client/i18n'
import { createContainerStructure } from 'client/utils/createStructureUtils'
import { EntityWithChildIdsMigrationType } from 'common/types/entities/EntityInterface'
import { createSearch } from 'src/editor/shared/entities/search/create-search'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'

export const createSearchFromLibrary = (
  container: EntityWithChildIdsMigrationType,
  locale: string,
  position = 0,
) => {
  const fixedT = i18n.getFixedT(locale)

  const { structure, descendantEntity } = createContainerStructure(
    container,
    locale,
    position,
  )

  const search = createSearch(
    descendantEntity.id,
    descendantEntity.masterBlockId,
  )

  search.input.placeholder = fixedT('components.search.placeholder')
  search.seeMore.text = fixedT('components.search.see_more')

  return {
    ...structure,
    [descendantEntity.id]: {
      ...descendantEntity,
      childIds: insertChild(descendantEntity.childIds, search.id, position),
    },
    [search.id]: search,
  }
}
